import { render, staticRenderFns } from "./updateHolidayData.vue?vue&type=template&id=2aa6ed85&scoped=true&"
import script from "./updateHolidayData.vue?vue&type=script&lang=js&"
export * from "./updateHolidayData.vue?vue&type=script&lang=js&"
import style0 from "./updateHolidayData.vue?vue&type=style&index=0&id=2aa6ed85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa6ed85",
  null
  
)

export default component.exports